import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy,CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule , ReactiveFormsModule} from '@angular/forms';
import { AppComponent } from './app.component';
// import { DropdownModule } from 'ng2-bootstrap/dropdown';
import { TabsModule } from 'ng2-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { HttpModule, JsonpModule } from '@angular/http';
// import { ChartsModule } from 'ng2-charts/ng2-charts';
import { AsideToggleDirective } from './shared/aside.directive';
import { BreadcrumbsComponent } from './shared/breadcrumb.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// Routing Module
import { AppRoutingModule } from './app.routing';

// Layouts 
// import { FullLayoutComponent } from './layouts/full-layout.component';
// import { SimpleLayoutComponent } from './layouts/simple-layout.component';
// import { LoaderComponent } from './loader/loader.component';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

// import  * as ng2Bootstrap from 'ng2-bootstrap/ng2-bootstrap';

// Shared module import
import { ShareModule } from './share/share.module';
// import { AuthorModule } from './author/author.module';

// module import for external library
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';
import { MyDatePickerModule } from 'mydatepicker';
import { MyDateRangePickerModule } from 'mydaterangepicker';
// import { SplitPaneModule } from 'ng2-split-pane/lib/ng2-split-pane';
// import { SplitModule } from 'ng2-split'
import { DragulaModule, DragulaService } from 'ng2-dragula/ng2-dragula';
import { Ng2DragDropModule } from 'ng2-drag-drop';
import { ImageUploadModule } from "angular2-image-upload";
import { UiSwitchModule } from 'ngx-toggle-switch/src';
import { FancyImageUploaderModule } from 'ng2-fancy-image-uploader';
import { GetItemService } from './get-item.service';
import { TagInputModule } from 'ngx-chips';
import { AngularSplitModule } from 'angular-split';

//cookie service
import { CookieService } from 'ngx-cookie-service';

//auth service
import { AuthServiceService } from './auth-service.service'
import { ChartsModule } from 'ng2-charts';
import 'chart.piecelabel.js'; // after 'ng2-charts'
// import { ChartModule } from 'angular-highcharts';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { PagerService } from './_services/index';
import { SafePipePipe } from './safe-pipe.pipe';


// new aplication ---- services ---------------------
import { ScoraModalModuleModule} from "./application/core-module";
import { GlobleApiService } from "./application/services";
import { AuthInterceptorService } from "./application/core/auth-interceptor.service";
import { GlobleDataShearService , UpcomingTestService} from "./application/services";

@NgModule({
  imports: [ 
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    // DropdownModule.forRoot(),
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    ChartsModule,
    HttpModule,
	HttpClientModule,
    FormsModule,
    // ChartModule,
    ReactiveFormsModule,
    // ng2Bootstrap.Ng2BootstrapModule,
    ShareModule,
    // AuthorModule,
    BrowserAnimationsModule,

    Angular2FontawesomeModule,
    AngularMultiSelectModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    // SplitPaneModule,
    // SplitModule,
    DragulaModule,
    Ng2DragDropModule.forRoot(),
    ImageUploadModule.forRoot(),
    UiSwitchModule,
    FancyImageUploaderModule,
    TagInputModule,
    AngularSplitModule,
    DeviceDetectorModule.forRoot(),
    ScoraModalModuleModule

  ],
  declarations: [
    AppComponent,
    // FullLayoutComponent,
    // SimpleLayoutComponent,
    BreadcrumbsComponent,
    AsideToggleDirective,
    // LoaderComponent,
	SafePipePipe,
  ],

  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
    provide: LocationStrategy,
    useClass: HashLocationStrategy,
    
    }, GetItemService, CookieService, PagerService, AuthServiceService, Title,
    GlobleApiService,
    GlobleDataShearService,UpcomingTestService],
  bootstrap: [ AppComponent ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts